import React from 'react';
import {
  Card, CardBody, Col //, Button,
} from 'reactstrap';
import {withTranslation} from "react-i18next";
// import UserEditIcon from 'mdi-react/UserEditIcon';

const Profile = ({username, blogs_count, post_count, about, website, t}) => (
  <Col md={12} lg={6} xl={3} xs={12}>
    <Card>
      <CardBody className="profile__card">
        <div className="profile__information">
          <div className="profile__avatar">
            <img src={`https://images.hive.blog/u/${username}/avatar`} alt="avatar" />
          </div>
          <div className="profile__data">
            <p className="profile__name">@{username}</p>
            <p className="profile__work">{about}</p>
            <p className="profile__contact"><a href={website} target='_blank' rel="noopener noreferrer">{website}</a></p>
            {/* <Button disabled={true} color="primary" className="icon profile__btn"><p><UserEditIcon />Edit details</p></Button> */}
          </div>
        </div>
        <div className="profile__stats">
          <div className="profile__stat">
            <p className="profile__stat-number">{blogs_count}</p>
            <p className="profile__stat-title">{t('overview.profile.blogs')}</p>
          </div>
          <div className="profile__stat">
            <p className="profile__stat-number">{post_count}</p>
            <p className="profile__stat-title">{t('overview.profile.posts')}</p>
          </div>
          {/* <div className="profile__stat">
            <p className="profile__stat-number">12</p>
            <p className="profile__stat-title">Reports</p>
          </div> */}
        </div>
      </CardBody>
    </Card>
  </Col>
);

export default withTranslation('dashboard')(Profile);
